import { lazy } from "react";

import { RoutePathBuilder } from "@/common/builders/routePath";
import AuthorizedRoute from "@/common/components/Auth/AuthorizedRoute";
import { Loadable } from "@/common/components/Loadable";
import { ROUTE_PATH } from "@/common/constants/routing";
import { AppPermission } from "@/core/api/generated/v1";

const ChatsPage = Loadable(lazy(() => import("../../MainAppView/Chats/ChatsPage")));
const ChatViewPage = Loadable(lazy(() => import("../../MainAppView/Chats/ChatViewPage")));
const NegotiationViewPage = Loadable(
  lazy(() => import("../../MainAppView/Negotiations/NegotiationViewPage")),
);
const NegotiationsPage = Loadable(
  lazy(() => import("../../MainAppView/Negotiations/NegotiationsPage")),
);

export function CommunicationRoutes() {
  return (
    <>
      {/* Chat */}
      <AuthorizedRoute
        permissions={[AppPermission.FleetAppAccess, AppPermission.ChatRead]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.CHATS())}
        render={() => <ChatsPage />}
      />
      <AuthorizedRoute
        permissions={[AppPermission.ChatRead]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.CHAT_VIEW())}
        render={() => <ChatViewPage />}
      />
      <AuthorizedRoute
        permissions={[AppPermission.ChatRead]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.CHAT_VIEW_BY_SCOPE())}
        render={() => <ChatViewPage />}
      />

      {/* Negotiation */}
      <AuthorizedRoute
        permissions={[AppPermission.FleetAppAccess, AppPermission.NegotiationRead]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.NEGOTIATIONS)}
        render={() => <NegotiationsPage />}
      />
      <AuthorizedRoute
        permissions={[AppPermission.FleetAppAccess, AppPermission.NegotiationRead]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.NEGOTIATION_VIEW())}
        render={() => <NegotiationViewPage />}
      />
    </>
  );
}
